<template>
  <v-container>
    <v-slide-y-transition mode="out-in">
      <v-layout column>
        <v-flex xs12 sm6>
          <v-text-field
            v-model="search"
            solo
            append-icon="search"
            label="Search ...">
          </v-text-field>
        </v-flex>
        <v-flex v-if="contacts && contacts.length === 0" xs6>
          <SharedContentLoader v-for="i in 5" :key="i"></SharedContentLoader>
        </v-flex>
        <v-flex v-else xs6 class="mt-2">
          <v-list two-line>
            <template v-for="(contact, key) in filteredContacts">
              <v-list-tile avatar @click="showContact = true; currentContactKey = key">
                <v-list-tile-content>
                  <v-list-tile-title>{{ contact.firstName }} {{ contact.lastName }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ contact.entreprise }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-chip color="green" v-if="contact.type">{{ contact.type }}</v-chip>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
    <v-dialog v-if="currentContactKey" v-model="showContact" width="600">
      <v-layout row>
        <v-flex xs12>
          <v-card>
            <v-layout column fill-height>
              <v-card-title>
                <v-btn dark icon @click="showContact = false">
                  <v-icon>chevron_left</v-icon>
                </v-btn>

                <v-spacer></v-spacer>

                <v-chip color="green" v-if="dynamicContact.type">{{ dynamicContact.type }}</v-chip>

                <v-btn dark icon class="mr-3" @click="showContact = false; showContactEdit = true">
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-card-title>

              <v-spacer></v-spacer>

              <v-card-title class="white--text pl-5 mb-3">
                <div class="display-1 pl-2 pt-1">
                  <span>
                  {{ dynamicContact.firstName }} {{ dynamicContact.lastName }} {{ dynamicContact.entreprise ? ` -
                  ${dynamicContact.entreprise}` : '' }}</span>
                  <v-subheader class="pl-0">
                    <a target="_blank" :href="dynamicContact.website">{{ dynamicContact.website }}</a>
                    <span v-if="dynamicContact.date">&nbsp; - Prise de contact le : {{ dynamicContact.date }}</span>
                  </v-subheader>
                </div>
              </v-card-title>
            </v-layout>

            <v-list two-line>
              <v-list-tile @click="">
                <v-list-tile-action>
                  <v-icon color="">phone</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{ dynamicContact.mobileNumber || 'Pas de téléphone mobile' }}</v-list-tile-title>
                  <v-list-tile-sub-title>Mobile</v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon>chat</v-icon>
                </v-list-tile-action>
              </v-list-tile>

              <v-list-tile @click="">
                <v-list-tile-action></v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{ dynamicContact.fixNumber || 'Pas de téléphone fixe' }}</v-list-tile-title>
                  <v-list-tile-sub-title>Work</v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon>chat</v-icon>
                </v-list-tile-action>
              </v-list-tile>

              <v-divider inset></v-divider>

              <v-list-tile @click="">
                <v-list-tile-action>
                  <v-icon color="">mail</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{ dynamicContact.personalEmail || 'Pas d\'adresse mail personnelle' }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>Personal</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="">
                <v-list-tile-action></v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{ dynamicContact.workEmail || 'Pas d\'adresse mail professionnelle' }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>Work</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-divider inset></v-divider>

              <v-list-tile @click="">
                <v-list-tile-action>
                  <v-icon color="">location_on</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{ dynamicContact.adressLine1 || 'Pas d\'adresse défnie' }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ dynamicContact.adressLine2 || '' }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <template
                v-if="dynamicContact.facebook || dynamicContact.twitter || dynamicContact.instagram || dynamicContact.linkedin">

                <v-divider inset></v-divider>

                <v-list-tile :href="dynamicContact.facebook" target="_blank" v-if="dynamicContact.facebook">
                  <v-list-tile-action>
                    <v-icon color="">fab fa-facebook</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                    <v-list-tile-title>{{ dynamicContact.facebook }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>Facebook</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile :href="dynamicContact.twitter" target="_blank" v-if="dynamicContact.twitter">
                  <v-list-tile-action>
                    <v-icon color="">fab fa-twitter-square</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                    <v-list-tile-title>{{ dynamicContact.twitter }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>Twitter</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile :href="dynamicContact.linkedin" target="_blank" v-if="dynamicContact.linkedin">
                  <v-list-tile-action>
                    <v-icon color="">fab fa-linkedin</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                    <v-list-tile-title>{{ dynamicContact.linkedin }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>LinkedIn</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile :href="dynamicContact.instagram" target="_blank" v-if="dynamicContact.instagram">
                  <v-list-tile-action>
                    <v-icon color="">fab fa-instagram</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                    <v-list-tile-title>{{ dynamicContact.instagram }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>Instagram</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-divider inset></v-divider>

                <v-list-group no-action>
                  <v-list-tile slot="activator">
                    <v-list-tile-content>
                      <v-list-tile-title>Notes</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-container>
                    {{ dynamicContact.notes || 'Pas de notes renseignées' }}
                  </v-container>
                </v-list-group>

              </template>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>
    <v-dialog v-if="currentContactKey" v-model="showContactEdit" width="800">
      <v-layout row>
        <v-flex xs12>
          <v-card>
            <v-layout column fill-height>
              <v-card-title>
                <v-btn dark icon @click="showContactEdit = false; showContact = true">
                  <v-icon>chevron_left</v-icon>
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn dark icon class="mr-3" @click="remove">
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-card-title>

              <v-spacer></v-spacer>
            </v-layout>

            <v-container grid-list-md>
              <v-form ref="form" v-model="contactFormValid" lazy-validation>
                <v-layout>
                  <v-flex xs6>
                    <v-text-field v-model="dynamicContact.firstName" :rules="textRule" label="Prénom"
                                  required></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field v-model="dynamicContact.lastName" :rules="textRule" label="Nom"
                                  required></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex xs6>
                    <v-text-field v-model="dynamicContact.entreprise" :rules="textRule" label="Entreprise"
                                  required></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field v-model="dynamicContact.website" :rules="textRule" label="Site Web"
                                  required></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex xs6>
                    <v-text-field v-model="dynamicContact.adressLine1" :rules="textRule" label="Adresse ligne 1"
                                  required></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field v-model="dynamicContact.adressLine2" :rules="textRule" label="Adresse ligne 2"
                                  required></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex xs6>
                    <v-text-field v-model="dynamicContact.fixNumber" :rules="textRule" label="Numéro fixe"
                                  required></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field v-model="dynamicContact.mobileNumber" :rules="textRule" label="Numéro portable"
                                  required></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex xs6>
                    <v-text-field v-model="dynamicContact.workEmail" :rules="textRule" label="Email pro"
                                  required></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field v-model="dynamicContact.personalEmail" :rules="textRule" label="Email personel"
                                  required></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex xs6>
                    <v-text-field v-model="dynamicContact.type" :rules="textRule" label="Type de contact"
                                  required></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-menu ref="menuDate" :close-on-content-click="false" v-model="menuDate" :nudge-right="40"
                            :return-value.sync="dynamicContact.date" lazy transition="scale-transition" offset-y
                            full-width
                            min-width="290px">
                      <v-text-field slot="activator" v-model="dynamicContact.date" label="Date de prise de contact"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                      <v-date-picker v-model="dynamicContact.date"
                                     @input="$refs.menuDate.save(dynamicContact.date)"></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex xs6>
                    <v-text-field prepend-icon="fab fa-facebook" v-model="dynamicContact.facebook" :rules="textRule"
                                  label="Facebook"
                                  required></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field prepend-icon="fab fa-linkedin" v-model="dynamicContact.linkedin" :rules="textRule"
                                  label="LinkedIn"
                                  required></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex xs6>
                    <v-text-field prepend-icon="fab fa-instagram" v-model="dynamicContact.instagram" :rules="textRule"
                                  label="Instagram"
                                  required></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field prepend-icon="fab fa-twitter-square" v-model="dynamicContact.twitter"
                                  :rules="textRule" label="Twitter"
                                  required></v-text-field>
                  </v-flex>
                </v-layout>

                <v-textarea v-model="dynamicContact.notes" :rules="textRule" label="Notes"
                            required></v-textarea>

                <v-btn :disabled="!contactFormValid" @click="submit">
                  submit
                </v-btn>
              </v-form>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>
  </v-container>
</template>

<script>
  import SharedContentLoader from './Shared/SharedContentLoader';

  export default {
    name: 'contacts',
    components: {
      SharedContentLoader,
    },
    data() {
      return {
        contacts: [],
        search: '',
        showContact: false,
        showContactEdit: false,
        currentContactKey: null,
        contactFormValid: false,
        textRule: [() => true],
        // textRule: [v => !!v || 'Le champ ne peut pas être vide'],
        menuDate: false,
      };
    },
    computed: {
      dynamicContact() {
        if (this.contacts && Object.keys(this.contacts).length === 0) {
          return {};
        }
        return this.contacts[this.currentContactKey];
      },
      filteredContacts() {
        if (this.search === '') {
          return this.contacts;
        }

        const arr = Object.keys(this.contacts).map(k => this.contacts[k]);

        return arr.filter(contact =>
          contact.firstName.toLowerCase().includes(this.search.toLowerCase()) ||
          contact.lastName.toLowerCase().includes(this.search.toLowerCase()) ||
          contact.entreprise.toLowerCase().includes(this.search.toLowerCase()),
        );
      },
    },
    methods: {
      async remove() {
        await this.$database()
                  .ref(`contacts/${this.currentContactKey}`)
                  .remove();
        this.showContact = false;
        this.showContactEdit = false;
      },
      async submit() {
        await this.$database()
                  .ref(`contacts/${this.currentContactKey}`)
                  .update(this.dynamicContact);
        this.showContact = true;
        this.showContactEdit = false;
      },
      async fetchContacts() {
        await this.$database()
                  .ref('contacts')
                  .on('value', (contacts) => {
                    this.contacts = contacts.val();
                  });
      },
    },
    mounted() {
      this.fetchContacts();

      if (this.$route.query.open) {
        this.currentContactKey = this.$route.query.open;
        this.showContactEdit = true;
      }
    },
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Contacts.vue